import * as React from "react";
import {
  EmailField,
  TextField,
  FunctionField,
  DateField,
  EditButton,
  TextInput,
} from "react-admin";
import { DateRangeInput, NumberRangeInput } from "src/components/input";
import { phoneNumberFormat } from "../../common/UtilFunctions";
import { Datagrid, IfCanAccess, List } from "src/enterprise/ra-rbac";

const listFilters = [
  <TextInput source="search" label="Search" alwaysOn />,

];

export const TerritoryList = (props) => {
  return (
    <List {...props} filters={listFilters} queryOptions={{ cacheTime: 0 }}>
      <Datagrid>
        <TextField source="id" />
        <TextField source="legacy_id" label="Legacy ID" />
        <TextField source="name" />
        <EmailField source="email" />
        <TextField source="shipping_name" label="Shipping Name" />
        <DateField source="created_at" label="Created At" />
        <IfCanAccess action="edit">
          <EditButton />
        </IfCanAccess>
      </Datagrid>
    </List>
  );
};
